<div>
  <div class="d-flex align-items-center gap-2 justify-content-center align-items-center h-100">
    <nb-toggle
      [title]="title"
      [id]="params.field"
      (checkedChange)="onChange(!value)"
      [disabled]="params.canEdit === false"
      [(ngModel)]="value"/>
  </div>
</div>
